module.exports = __webpack_public_path__ + "static/img/5.b1717c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/5.png
// module id = MMXS
// module chunks = 0